import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger';

import auth from './modules/auth'
import rips from './rips';
import filters from './filters';
import catalogs from './catalogs';


Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const plugins = [];

if (debug) plugins.push(createLogger())

export default new Vuex.Store({
  modules: {
    auth,
    rips,
    filters,
    catalogs
  },
  plugins,
  strict: debug
})
